import React, {Component} from 'react';
import axios from 'axios';
import $ from 'jquery';
import './ManageLiveRoomBackground.css';
import BackgroundModal from './components/BackgroundModal';
import DeleteModal from './components/DeleteModal';
import Toast from './components/Toast';
import SVGAPlayer from '../../components/SVGAPlayer/SVGAPlayer';
import LottiePlayer from '../../components/LottiePlayer/LottiePlayer';

export default class ManageLiveRoomBackground extends Component {
    constructor(props) {
        super(props);
        this.state = {
            backgrounds: [],
            loading: false,
            showModal: false,
            showDeleteModal: false,
            currentItem: null,
            isEditMode: false,
            formData: {
                id: null,
                level: 1,
                color: '#FF6B6B',
                background: '',
                stage: null,
                solo_stage: '',
                duet_stage: '',
                thumbnail: '',
                name: '',
                tag: '',
                status: 1
            },
            uploadingFields: {},
            toast: {
                show: false,
                type: 'success', // 'success' or 'error'
                message: ''
            }
        };
    }

    categoryType = () => this.props.location.pathname.endsWith('/room-gift') ? 'ROOM_GIFT' : 'SYSTEM';

    componentDidUpdate(previous) {
        if (previous.location.pathname !== this.props.location.pathname) {
            this.setState({ showModal: false, uidDraft: '', invalidLiveRooms: [] });
            this.loadBackgrounds();
        }
    }

    componentDidMount() {
        this.loadBackgrounds();
    }

    loadBackgrounds = async () => {
        this.setState({ loading: true });
        try {
            // Gọi API mới
            const requestCategory = this.categoryType();
            const response = await axios.get(global.config.apiDomain + '/mc-live-room/web/live-room-levels?type=' + this.categoryType());
            
            if (requestCategory !== this.categoryType()) return;
            if (response.data && response.data.status === 'OK' && response.data.data && Array.isArray(response.data.data.liveRoomLevels)) {
                // Chuyển đổi dữ liệu từ API format sang format component
                const backgrounds = response.data.data.liveRoomLevels.map(item => ({
                    ...item,
                    type: item.type || 'SYSTEM',
                    liveRooms: item.liveRooms || [],
                    id: item.id,
                    name: item.name,
                    level: item.level,
                    color: item.color,
                    background: item.background,
                    stage: item.stage,
                    solo_stage: item.soloStage,  // Convert camelCase to snake_case
                    duet_stage: item.duetStage,  // Convert camelCase to snake_case
                    thumbnail: item.thumbnail,
                    status: item.status || 0  // Default to 1 if not provided
                }));
                this.setState({ backgrounds });
            } else {
                // Nếu API không trả về dữ liệu hợp lệ, dùng dữ liệu mẫu

            }
        } catch (error) {
            console.log('Lỗi:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    openModal = (item = null) => {
        if (item) {
            // Chế độ sửa
            this.setState({
                showModal: true,
                isEditMode: true,
                currentItem: item,
                uidDraft: '', invalidLiveRooms: [],
                formData: { ...item }
            });
        } else {
            // Chế độ thêm mới
            this.setState({
                showModal: true,
                isEditMode: false,
                currentItem: null,
                uidDraft: '', invalidLiveRooms: [],
                formData: {
                    type: this.categoryType(), startTime: null, endTime: null, liveRooms: [],
                    id: null,
                    level: 1,
                    color: '#FF6B6B',
                    background: '',
                    stage: null,
                    solo_stage: '',
                    duet_stage: '',
                    thumbnail: '',
                    name: '',
                    tag: '',
                    status: 1
                }
            });
        }
    };

    closeModal = () => {
        this.setState({
            showModal: false,
            isEditMode: false,
            currentItem: null,
            uploadingFields: {}
        });
    };

    openDeleteModal = (item) => {
        this.setState({
            showDeleteModal: true,
            currentItem: item
        });
    };

    closeDeleteModal = () => {
        this.setState({
            showDeleteModal: false,
            currentItem: null
        });
    };

    showToast = (type, message) => {
        this.setState({
            toast: {
                show: true,
                type: type,
                message: message
            }
        });
    };

    closeToast = () => {
        this.setState({
            toast: {
                show: false,
                type: 'success',
                message: ''
            }
        });
    };

    // Method để force reset upload state nếu cần
    resetUploadState = (field) => {
        console.log('Force reset upload state for field:', field);
        this.setState(prevState => ({
            uploadingFields: {
                ...prevState.uploadingFields,
                [field]: false
            }
        }));
    };

    handleInputChange = (field, value) => {
        // Handle hex color input
        if (field === 'color') {
            // Auto add # if not present
            if (value && !value.startsWith('#')) {
                value = '#' + value;
            }
            // Convert to uppercase
            value = value.toUpperCase();
            
            // Allow partial input while typing, but validate characters
            if (value.length > 1) {
                const hexChars = value.substring(1);
                const validHexRegex = /^[A-Fa-f0-9]*$/;
                if (!validHexRegex.test(hexChars)) {
                    // Invalid hex characters, don't update
                    return;
                }
            }
            
            // Limit length to 7 characters (#FFFFFF)
            if (value.length > 7) {
                value = value.substring(0, 7);
            }
        }
        
        this.setState({
            formData: {
                ...this.state.formData,
                [field]: value
            },
            ...(field === 'type' ? {uidDraft: '', invalidLiveRooms: []} : {})
        });
    };

    uploadImage = async (file, field) => {
        if (!file) {
            console.log('No file selected');
            return;
        }

        console.log('Starting upload for field:', field, 'File:', file.name);

        this.setState({
            uploadingFields: {
                ...this.state.uploadingFields,
                [field]: true
            }
        });

        try {
            // Tạo tên file unique
            const timestamp = Date.now();
            const extension = file.name.split('.').pop();
            const keyName = `live-room-bg/${field}_${timestamp}.${extension}`;

            const formData = new FormData();
            formData.append('file', file);
            formData.append('bucketName', 'ikara-data/room-background');
            formData.append('objectKey', keyName);

            const response = await $.ajax({
                url: global.config.apiDomain + '/web.UploadFile',
                data: formData,
                processData: false,
                contentType: false,
                type: 'POST'
            });

            const imageUrl = `https://data4.ikara.co/data/minio/ikara-data/room-background/${keyName}`;
            
            this.setState({
                formData: {
                    ...this.state.formData,
                    [field]: imageUrl
                }
            });

        } catch (error) {
            console.error('Upload error for field:', field, error);
            this.showToast('error', `Lỗi upload ${field}. Vui lòng thử lại.`);
        } finally {
            console.log('Upload finished for field:', field);
            // Đảm bảo luôn reset loading state
            this.setState(prevState => ({
                uploadingFields: {
                    ...prevState.uploadingFields,
                    [field]: false
                }
            }));
        }
    };

    handleFileChange = (event, field) => {
        console.log('File change event for field:', field);
        const file = event.target.files[0];
        
        if (file) {
            console.log('File selected:', file.name, 'Size:', file.size, 'Type:', file.type);
            this.uploadImage(file, field);
        } else {
            console.log('No file selected for field:', field);
        }
        
        // Reset input value để có thể chọn lại cùng file
        event.target.value = '';
    };

    saveBackground = async () => {
        const { formData, isEditMode } = this.state;
        
        // Validation - Kiểm tra tất cả các trường bắt buộc
        if (!formData.name.trim()) {
            this.showToast('error', 'Vui lòng nhập tên nền phòng');
            return;
        }
        
        if (formData.level < 1) {
            this.showToast('error', 'Level phải lớn hơn 0');
            return;
        }
        
        // Validate hex color
        const hexRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
        if (!hexRegex.test(formData.color)) {
            this.showToast('error', 'Mã màu hex không hợp lệ (ví dụ: #FF6B6B)');
            return;
        }


        if (formData.startTime != null && formData.endTime != null && formData.endTime <= formData.startTime) {
            this.showToast('error', 'Kết thúc phải sau thời điểm bắt đầu.'); return;
        }
        if (this.categoryType() === 'ROOM_GIFT' && (!(formData.liveRooms || []).length || (formData.liveRooms || []).length > 100 || (this.state.uidDraft || '').trim())) {
            this.showToast('error', 'Chọn từ 1–100 phòng; thêm hoặc xóa nội dung UID còn ở ô nhập trước khi lưu.'); return;
        }
        this.setState({ loading: true, invalidLiveRooms: [] });

        try {
            // Chuyển đổi dữ liệu từ component format sang API format
            const apiData = {
                type: this.categoryType(),
                revision: formData.revision,
                startTime: formData.startTime == null ? null : formData.startTime,
                endTime: formData.endTime == null ? null : formData.endTime,
                liveRoomReferences: this.categoryType() === 'ROOM_GIFT' ? (formData.liveRooms || []).map(liveRoom => ({liveRoomId: liveRoom.liveRoomId, uid: liveRoom.uid})) : [],
                name: formData.name,
                tag: this.categoryType() === 'ROOM_GIFT' ? (formData.tag || '').trim() || null : null,
                level: formData.level,
                color: formData.color,
                background: !formData.background || formData.background.trim() === '' ? null : formData.background,
                stage: !formData.stage || formData.stage.trim() === '' ? null : formData.stage,
                soloStage: !formData.solo_stage || formData.solo_stage.trim() === '' ? null : formData.solo_stage,  // Convert snake_case to camelCase
                duetStage: !formData.duet_stage || formData.duet_stage.trim() === '' ? null : formData.duet_stage,  // Convert snake_case to camelCase
                thumbnail: !formData.thumbnail || formData.thumbnail.trim() === '' ? null : formData.thumbnail,
                status: formData.status
            };

            // Nếu là edit mode, thêm id vào body để update
            if (isEditMode && formData.id) {
                apiData.id = formData.id;
            }

            // Tách thành 2 API riêng biệt: POST cho tạo mới, PUT cho cập nhật
            const response = isEditMode 
                ? await axios.put(
                    global.config.apiDomain + '/mc-live-room/web/live-room-levels',
                    apiData
                )
                : await axios.post(
                    global.config.apiDomain + '/mc-live-room/web/live-room-levels',
                    apiData
                );

            if (response.data && response.data.status === 'OK') {
                this.showToast('success', isEditMode ? 'Cập nhật thành công!' : 'Thêm mới thành công!');
                this.setState({ showModal: false });
                const path = '/admin/manage-live-room-background/' + (apiData.type === 'ROOM_GIFT' ? 'room-gift' : 'system');
                if (this.props.location.pathname !== path) this.props.history.replace(path);
                else this.loadBackgrounds();
            } else {
                const failure = new Error(response.data?.message || 'Lưu không thành công');
                failure.response = response; throw failure;
            }
        } catch (error) {
            this.setState({ invalidLiveRooms: error.response?.data?.data?.invalidLiveRooms || [] });
            console.error('Save error:', error);
            const errorMessage = error.response?.data?.message || error.message || 'Lỗi khi lưu dữ liệu. Vui lòng thử lại.';
            this.showToast('error', errorMessage);
        } finally {
            this.setState({ loading: false });
        }
    };

    deleteBackground = async () => {
        const { currentItem } = this.state;
        
        this.setState({ loading: true });

        try {
            // Sử dụng DELETE với body chứa id
            const response = await axios.delete(
                global.config.apiDomain + '/mc-live-room/web/live-room-levels',
                {
                    data: {
                        id: currentItem.id, revision: currentItem.revision
                    }
                }
            );

            if (response.data && response.data.status === 'OK') {
                this.showToast('success', 'Xóa thành công!');
                this.setState({ showDeleteModal: false });
                this.loadBackgrounds(); // Reload danh sách
            } else {
                throw new Error(response.data?.message || 'API response không hợp lệ');
            }
        } catch (error) {
            console.error('Delete error:', error);
            const errorMessage = error.response?.data?.message || error.message || 'Lỗi khi xóa dữ liệu. Vui lòng thử lại.';
            this.showToast('error', errorMessage);
        } finally {
            this.setState({ loading: false });
        }
    };

    handleRemoveImage = (field) => {
        // Đối với trường stage, set null thay vì chuỗi rỗng
        const value = field === 'stage' ? null : '';
        
        this.setState({
            formData: {
                ...this.state.formData,
                [field]: value
            },
            ...(field === 'type' ? {uidDraft: '', invalidLiveRooms: []} : {})
        });
    };

    // Helper function to check if file is a previewable image
    isPreviewableImage = (url) => {
        if (!url) return false;
        
        // Get file extension from URL
        const extension = url.split('.').pop().toLowerCase();
        
        // List of image formats that can be previewed
        const previewableFormats = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'];
        
        return previewableFormats.includes(extension);
    };

    // Helper function to check if file is SVGA
    isSVGAFile = (url) => {
        if (!url) return false;
        
        // Get file extension from URL
        const extension = url.split('.').pop().toLowerCase();
        
        return extension === 'svga';
    };

    // Helper function to check if file is Lottie
    isLottieFile = (url) => {
        if (!url) return false;
        
        // Get file extension from URL
        const extension = url.split('.').pop().toLowerCase();
        
        // Check if it's a JSON file and potentially a Lottie animation
        if (extension === 'json') {
            // Additional check: if URL contains 'lottie' or 'animation' keywords
            const urlLower = url.toLowerCase();
            if (urlLower.includes('lottie') || urlLower.includes('animation') || urlLower.includes('data.json')) {
                return true;
            }
            // For now, assume all JSON files are Lottie (you can make this more specific)
            return true;
        }
        
        return false;
    };

    // Helper function to get filename from URL
    getFilenameFromUrl = (url) => {
        if (!url) return '';
        return url.split('/').pop();
    };

    renderImageUpload = (field, label, required = false) => {
        const { formData, uploadingFields } = this.state;
        const isUploading = uploadingFields[field];
        const imageUrl = formData[field];

        return (
            <div className="form-group">
                <label className={`form-label ${required ? 'required' : ''}`}>{label}</label>
                <div className="upload-section">
                    {imageUrl && imageUrl !== null ? (
                        <div className="image-preview-container">
                            {this.isPreviewableImage(imageUrl) ? (
                                <img 
                                    src={imageUrl} 
                                    alt={label} 
                                    className="upload-preview"
                                />
                            ) : this.isSVGAFile(imageUrl) ? (
                                <div className="svga-preview">
                                    <SVGAPlayer
                                        animatedUrl={imageUrl}
                                        width="100%"
                                        height="150px"
                                        autoPlay={true}
                                        showControls={true}
                                        giftName={this.getFilenameFromUrl(imageUrl)}
                                    />
                                </div>
                            ) : this.isLottieFile(imageUrl) ? (
                                <div className="lottie-preview">
                                    <LottiePlayer
                                        animatedUrl={imageUrl}
                                        width="200px"
                                        height="120px"
                                        autoPlay={true}
                                        showControls={true}
                                        giftName={this.getFilenameFromUrl(imageUrl)}
                                    />
                                </div>
                            ) : (
                                <div className="file-preview">
                                    <div className="file-info">
                                        <i className="fas fa-file"></i>
                                        <div className="file-details">
                                            <div className="file-name">{this.getFilenameFromUrl(imageUrl)}</div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <button
                                type="button"
                                className="remove-image-btn"
                                onClick={() => this.handleRemoveImage(field)}
                                title="Xóa file"
                            >
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                    ) : (
                        <div className="no-image">Chưa có file</div>
                    )}
                    
                    <input
                        type="file"
                        accept="image/*,.webp,.svga,.json,.gif"
                        onChange={(e) => this.handleFileChange(e, field)}
                        disabled={isUploading}
                        style={{ display: 'none' }}
                        id={`upload-${field}`}
                    />
                    
                    <label 
                        htmlFor={`upload-${field}`} 
                        className={`upload-btn ${isUploading ? 'disabled' : ''}`}
                        style={{ 
                            pointerEvents: isUploading ? 'none' : 'auto',
                            opacity: isUploading ? 0.6 : 1 
                        }}
                    >
                        {isUploading ? (
                            <>
                                <span className="loading-spinner"></span>
                                Đang upload...
                            </>
                        ) : (
                            'Chọn ảnh'
                        )}
                    </label>
                </div>
            </div>
        );
    };

    render() {
        const { 
            backgrounds, 
            loading, 
            showModal, 
            showDeleteModal, 
            formData, 
            isEditMode, 
            currentItem,
            toast
        } = this.state;

        return (
            <div className="manage-live-room-bg">
                    <div className="container-fluid">
                    <h1>Quản lý nền phòng — {this.categoryType() === 'ROOM_GIFT' ? 'Tặng nền phòng riêng' : 'Hệ thống'}</h1>

                    <button 
                        className="btn lrb-add-new-btn"
                        onClick={() => this.openModal()}
                        disabled={loading}
                    >
                        <i className="fas fa-plus"></i> Thêm nền phòng mới
                    </button>

                    {loading && backgrounds.length === 0 ? (
                        <div className="text-center">
                            <div className="loading-spinner"></div>
                            <p>Đang tải dữ liệu...</p>
                        </div>
                    ) : backgrounds.length === 0 ? (
                        <div className="empty-state">
                            <i className="fas fa-image"></i>
                            <h3>Chưa có nền phòng nào</h3>
                            <p>Nhấn nút "Thêm nền phòng mới" để bắt đầu</p>
                        </div>
                    ) : (
                        <div className="lrb-table">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Tên nền phòng</th>
                                        <th>{this.categoryType() === 'ROOM_GIFT' ? 'Phòng nhận (UID hiện tại)' : 'Level'}</th>
                                        <th>Màu nền</th>
                                        <th>Trạng thái</th>
                                        <th>Background</th>
                                        <th>Bục sân khấu</th>
                                        <th>Bục Đơn ca</th>
                                        <th>Bục Song ca</th>
                                        <th>Thumbnail</th>
                                        <th>Thao tác</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {backgrounds.map((item) => (
                                        <tr key={item.id}>
                                            <td>
                                                <div className="name-cell" title={item.name || 'Chưa có tên'}>
                                                    {item.name || 'Chưa có tên'}
                                                </div>
                                            </td>
                                            <td>
                                                {item.type === 'ROOM_GIFT' ? <div style={{maxWidth: 280, whiteSpace: 'normal'}}>
                                                    {(item.liveRooms || []).map(liveRoom => <span key={liveRoom.liveRoomId} className="badge badge-light mr-1" title={liveRoom.name || 'Phòng không còn tồn tại'}>
                                                        {liveRoom.uid == null ? `Phòng đã mất (${liveRoom.liveRoomId})` : liveRoom.uid}
                                                    </span>)}
                                                </div> : <span className="level-badge">Level {item.level}</span>}
                                            </td>
                                            <td>
                                                <div className="color-display">
                                                    <div 
                                                        className="color-preview" 
                                                        style={{ backgroundColor: item.color }}
                                                        title={`Màu nền: ${item.color}`}
                                                    ></div>
                                                    <div className="color-hex">{item.color}</div>
                                                </div>
                                            </td>
                                            <td>
                                                <span className={`status-badge ${item.status === 1 ? 'status-active' : 'status-inactive'}`}>
                                                    {item.status === 1 ? 'Hiện' : 'Ẩn'} {' · '}{({UPCOMING:'Chưa đến giờ', ACTIVE:'Đang hiệu lực', EXPIRED:'Đã hết hạn'})[item.scheduleStatus] || ''}
                                                </span>
                                            </td>
                                            <td>
                                                {item.background ? (
                                                    this.isPreviewableImage(item.background) ? (
                                                        <img 
                                                            src={item.background} 
                                                            alt="Background" 
                                                            className="image-preview-table" 
                                                        />
                                                    ) : this.isSVGAFile(item.background) ? (
                                                        <div className="svga-preview-table">
                                                            <SVGAPlayer
                                                                animatedUrl={item.background}
                                                                width="80px"
                                                                height="60px"
                                                                autoPlay={false}
                                                                showControls={false}
                                                                giftName={this.getFilenameFromUrl(item.background)}
                                                            />
                                                        </div>
                                                    ) : this.isLottieFile(item.background) ? (
                                                        <div className="lottie-preview-table">
                                                            <LottiePlayer
                                                                animatedUrl={item.background}
                                                                width="80px"
                                                                height="60px"
                                                                autoPlay={true}
                                                                showControls={false}
                                                                giftName={this.getFilenameFromUrl(item.background)}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div className="file-preview-table">
                                                            <i className="fas fa-file"></i>
                                                            <div className="file-name-table">{this.getFilenameFromUrl(item.background)}</div>
                                                        </div>
                                                    )
                                                ) : (
                                                    <div className="no-image-table">Chưa có file</div>
                                                )}
                                            </td>
                                            <td>
                                                {item.stage ? (
                                                    this.isPreviewableImage(item.stage) ? (
                                                        <img 
                                                            src={item.stage} 
                                                            alt="Stage" 
                                                            className="image-preview-table" 
                                                        />
                                                    ) : this.isSVGAFile(item.stage) ? (
                                                        <div className="svga-preview-table">
                                                            <SVGAPlayer
                                                                animatedUrl={item.stage}
                                                                width="80px"
                                                                height="60px"
                                                                autoPlay={false}
                                                                showControls={false}
                                                                giftName={this.getFilenameFromUrl(item.stage)}
                                                            />
                                                        </div>
                                                    ) : this.isLottieFile(item.stage) ? (
                                                        <div className="lottie-preview-table">
                                                            <LottiePlayer
                                                                animatedUrl={item.stage}
                                                                width="80px"
                                                                height="60px"
                                                                autoPlay={true}
                                                                showControls={false}
                                                                giftName={this.getFilenameFromUrl(item.stage)}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div className="file-preview-table">
                                                            <i className="fas fa-file"></i>
                                                            <div className="file-name-table">{this.getFilenameFromUrl(item.stage)}</div>
                                                        </div>
                                                    )
                                                ) : (
                                                    <div className="no-image-table">Chưa có file</div>
                                                )}
                                            </td>
                                            <td>
                                                {item.solo_stage ? (
                                                    this.isPreviewableImage(item.solo_stage) ? (
                                                        <img 
                                                            src={item.solo_stage} 
                                                            alt="Solo Stage" 
                                                            className="image-preview-table" 
                                                        />
                                                    ) : this.isSVGAFile(item.solo_stage) ? (
                                                        <div className="svga-preview-table">
                                                            <SVGAPlayer
                                                                animatedUrl={item.solo_stage}
                                                                width="80px"
                                                                height="60px"
                                                                autoPlay={false}
                                                                showControls={false}
                                                                giftName={this.getFilenameFromUrl(item.solo_stage)}
                                                            />
                                                        </div>
                                                    ) : this.isLottieFile(item.solo_stage) ? (
                                                        <div className="lottie-preview-table">
                                                            <LottiePlayer
                                                                animatedUrl={item.solo_stage}
                                                                width="80px"
                                                                height="60px"
                                                                autoPlay={true}
                                                                showControls={false}
                                                                giftName={this.getFilenameFromUrl(item.solo_stage)}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div className="file-preview-table">
                                                            <i className="fas fa-file"></i>
                                                            <div className="file-name-table">{this.getFilenameFromUrl(item.solo_stage)}</div>
                                                        </div>
                                                    )
                                                ) : (
                                                    <div className="no-image-table">Chưa có file</div>
                                                )}
                                            </td>
                                            <td>
                                                {item.duet_stage ? (
                                                    this.isPreviewableImage(item.duet_stage) ? (
                                                        <img 
                                                            src={item.duet_stage} 
                                                            alt="Duet Stage" 
                                                            className="image-preview-table" 
                                                        />
                                                    ) : this.isSVGAFile(item.duet_stage) ? (
                                                        <div className="svga-preview-table">
                                                            <SVGAPlayer
                                                                animatedUrl={item.duet_stage}
                                                                width="80px"
                                                                height="60px"
                                                                autoPlay={false}
                                                                showControls={false}
                                                                giftName={this.getFilenameFromUrl(item.duet_stage)}
                                                            />
                                                        </div>
                                                    ) : this.isLottieFile(item.duet_stage) ? (
                                                        <div className="lottie-preview-table">
                                                            <LottiePlayer
                                                                animatedUrl={item.duet_stage}
                                                                width="80px"
                                                                height="60px"
                                                                autoPlay={true}
                                                                showControls={false}
                                                                giftName={this.getFilenameFromUrl(item.duet_stage)}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div className="file-preview-table">
                                                            <i className="fas fa-file"></i>
                                                            <div className="file-name-table">{this.getFilenameFromUrl(item.duet_stage)}</div>
                                                        </div>
                                                    )
                                                ) : (
                                                    <div className="no-image-table">Chưa có file</div>
                                                )}
                                            </td>
                                            <td>
                                                {item.thumbnail ? (
                                                    this.isPreviewableImage(item.thumbnail) ? (
                                                        <img 
                                                            src={item.thumbnail} 
                                                            alt="Thumbnail" 
                                                            className="image-preview-table" 
                                                        />
                                                    ) : this.isSVGAFile(item.thumbnail) ? (
                                                        <div className="svga-preview-table">
                                                            <SVGAPlayer
                                                                animatedUrl={item.thumbnail}
                                                                width="80px"
                                                                height="60px"
                                                                autoPlay={false}
                                                                showControls={false}
                                                                giftName={this.getFilenameFromUrl(item.thumbnail)}
                                                            />
                                                        </div>
                                                    ) : this.isLottieFile(item.thumbnail) ? (
                                                        <div className="lottie-preview-table">
                                                            <LottiePlayer
                                                                animatedUrl={item.thumbnail}
                                                                width="80px"
                                                                height="60px"
                                                                autoPlay={true}
                                                                showControls={false}
                                                                giftName={this.getFilenameFromUrl(item.thumbnail)}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div className="file-preview-table">
                                                            <i className="fas fa-file"></i>
                                                            <div className="file-name-table">{this.getFilenameFromUrl(item.thumbnail)}</div>
                                                        </div>
                                                    )
                                                ) : (
                                                    <div className="no-image-table">Chưa có file</div>
                                                )}
                                            </td>
                                            <td>
                                                <div className="actions-cell">
                                                    <button 
                                                        className="btn lrb-btn-edit"
                                                        onClick={() => this.openModal(item)}
                                                        title="Sửa"
                                                    >
                                                        <i className="fas fa-edit"></i>
                                                    </button>
                                                    <button 
                                                        className="btn lrb-btn-delete"
                                                        onClick={() => this.openDeleteModal(item)}
                                                        title="Xóa"
                                                    >
                                                        <i className="fas fa-trash"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                    </div>
                    )}

                    <BackgroundModal
                    invalidLiveRooms={this.state.invalidLiveRooms || []}
                    onDraftChange={uidDraft => this.setState({uidDraft})}
                        show={showModal}
                        isEditMode={isEditMode}
                        formData={formData}
                        categoryType={this.categoryType()}
                        loading={loading}
                        onClose={this.closeModal}
                        onSave={this.saveBackground}
                        onInputChange={this.handleInputChange}
                        renderImageUpload={this.renderImageUpload}
                    />

                    <DeleteModal
                        show={showDeleteModal}
                        currentItem={currentItem}
                        loading={loading}
                        onClose={this.closeDeleteModal}
                        onDelete={this.deleteBackground}
                    />

                    <Toast
                        show={toast.show}
                        type={toast.type}
                        message={toast.message}
                        onClose={this.closeToast}
                    />
                </div>
            </div>
        );
    }
}
